/* CLIKART Header behaviour: sticky, ticker, categories, drawer */
(function () {
  'use strict';

  // Theme's global.js may already define <sticky-header>. If not, define a lightweight one.
  if (!customElements.get('sticky-header')) {
    customElements.define('sticky-header', class extends HTMLElement {});
  }

  /* ---- Dark / Light theme ---- */
  const THEME_KEY = 'ck-theme';
  function applyTheme(t) {
    document.documentElement.setAttribute('data-theme', t);
    document.querySelectorAll('[data-ck-theme-label]').forEach(l => l.textContent = t === 'dark' ? 'Light' : 'Dark');
  }
  applyTheme(localStorage.getItem(THEME_KEY) || 'light');
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-ck-theme-toggle]'); if (!btn) return;
    const next = document.documentElement.getAttribute('data-theme') === 'dark' ? 'light' : 'dark';
    localStorage.setItem(THEME_KEY, next); applyTheme(next);
  });

  function initHeader(root) {
    if (!root || root.dataset.ckInit) return;
    root.dataset.ckInit = '1';

    /* ---- Sticky ---- */
    if (root.dataset.sticky === 'true') {
      let spacer = root.nextElementSibling;
      if (!spacer || !spacer.classList.contains('ck-header-spacer')) {
        spacer = document.createElement('div');
        spacer.className = 'ck-header-spacer';
        root.after(spacer);
      }
      let lastY = 0, stuck = false;
      const threshold = () => root.offsetHeight + 40;
      const onScroll = () => {
        const y = window.scrollY;
        if (!stuck && y > threshold()) {
          spacer.style.height = root.offsetHeight + 'px';
          spacer.classList.add('is-active');
          root.classList.add('is-stuck');
          stuck = true;
        } else if (stuck && y <= 10) {
          root.classList.remove('is-stuck');
          spacer.classList.remove('is-active');
          spacer.style.height = '';
          stuck = false;
        }
        lastY = y;
      };
      window.addEventListener('scroll', onScroll, { passive: true });
    }

    /* ---- Top bar ticker ---- */
    const ticker = root.querySelector('[data-ck-ticker]');
    if (ticker) {
      const msgs = ticker.querySelectorAll('.ck-topbar__msg');
      if (msgs.length > 1) {
        let i = 0;
        setInterval(() => {
          msgs[i].classList.remove('is-active');
          i = (i + 1) % msgs.length;
          msgs[i].classList.add('is-active');
        }, 3800);
      }
    }

    /* ---- Categories toggle (click for touch / keyboard) ---- */
    const cats = root.querySelector('[data-ck-cats]');
    if (cats) {
      const btn = cats.querySelector('[data-ck-cats-toggle]');
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        const open = cats.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', open);
      });
      document.addEventListener('click', (e) => {
        if (!cats.contains(e.target)) { cats.classList.remove('is-open'); btn.setAttribute('aria-expanded', 'false'); }
      });
    }

    /* ---- Mobile drawer ---- */
    const drawer = root.querySelector('[data-ck-drawer]');
    if (drawer) {
      const open = () => { drawer.classList.add('is-open'); drawer.setAttribute('aria-hidden', 'false'); document.body.style.overflow = 'hidden'; };
      const close = () => { drawer.classList.remove('is-open'); drawer.setAttribute('aria-hidden', 'true'); document.body.style.overflow = ''; };
      root.querySelectorAll('[data-ck-open-drawer]').forEach(b => b.addEventListener('click', open));
      drawer.querySelectorAll('[data-ck-close-drawer]').forEach(b => b.addEventListener('click', close));
      document.addEventListener('keyup', (e) => { if (e.key === 'Escape') close(); });

      drawer.querySelectorAll('[data-ck-tab]').forEach(tab => {
        tab.addEventListener('click', () => {
          drawer.querySelectorAll('[data-ck-tab]').forEach(t => t.classList.toggle('is-active', t === tab));
          drawer.querySelectorAll('[data-ck-panel]').forEach(p => p.classList.toggle('is-active', p.dataset.ckPanel === tab.dataset.ckTab));
        });
      });
    }
  }

  const boot = () => document.querySelectorAll('.ck-header-wrap').forEach(initHeader);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
